import gql from 'graphql-tag';
import APP_FRAGMENT from './app';

const USER_SETTINGS_FRAGMENT = gql`
  fragment BaseUserSetting on UserSetting {
    id
    setting
    userId
    value
    dateCreated
    dateUpdated
    app {
      ...BaseApp
    }
  }
  ${APP_FRAGMENT}
`;

export default USER_SETTINGS_FRAGMENT;
